import { FC, useCallback, useMemo } from 'react';
import { useField } from 'react-final-form';

import { Option } from '@beeline/design-system-react/extracted-styles';

import { DurationSelect, DurationSelectProps } from './DurationSelect';

export interface FormDurationSelectProps
  extends Omit<DurationSelectProps, 'values' | 'onChange'> {
  name: string;
}

const emptyValues: Option<string>[] = [];

export const FormDurationSelect: FC<FormDurationSelectProps> = ({
  name,
  required,
  ...rest
}) => {
  const validate = useCallback(
    (value: Option<string> | undefined) => {
      if (required && value === undefined) return 'Заполните поле';

      return '';
    },
    [required],
  );

  const { input, meta } = useField(name, { type: 'string', validate });
  const error = meta.touched ? meta.error : undefined;

  const handleChange = useCallback(
    (value: Option<string>[]) => {
      input.onChange(value[0]);
    },
    [input],
  );

  const values = useMemo((): Option<string>[] => {
    return input.value ? [input.value] : emptyValues;
  }, [input.value]);

  return (
    <DurationSelect
      {...rest}
      required={required}
      error={!!error}
      helperText={error}
      onChange={handleChange}
      values={values}
    />
  );
};
